import Vue from 'vue'
import Vuex from 'vuex'
import tabs from './modules/tabs'
import cachedata from './modules/cachedata'
import user from './modules/user'
import permission from './modules/permission'
import tagsView from './modules/tagsView'
import getters from './getter'
import app from './modules/app'
import menu from './modules/menu'
import expert from './modules/expert'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    tabs,
    cachedata,
    user,
    permission,
    app,
    tagsView,
    menu,
    expert
  },
  getters
})

export default store
